// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AppDownloadBannerController from "./app_download_banner_controller"
application.register("app-download-banner", AppDownloadBannerController)

import AdminQueueController from "./admin_queue_controller"
application.register("admin-queue", AdminQueueController)

import AdminIntakeController from "./admin_intake_controller"
application.register("admin-intake", AdminIntakeController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import Components__ColorPickerController from "./components/color_picker_controller"
application.register("components--color-picker", Components__ColorPickerController)

import Components__DropdownController from "./components/dropdown_controller"
application.register("components--dropdown", Components__DropdownController)

import Components__ImageUploadController from "./components/image_upload_controller"
application.register("components--image-upload", Components__ImageUploadController)

import Components__RadioButtonsController from "./components/radio_buttons_controller"
application.register("components--radio-buttons", Components__RadioButtonsController)

import Components__RichTextController from "./components/rich_text_controller"
application.register("components--rich-text", Components__RichTextController)

import Components__SubnavController from "./components/subnav_controller"
application.register("components--subnav", Components__SubnavController)

import Components__ToggleController from "./components/toggle_controller"
application.register("components--toggle", Components__ToggleController)

import DesignModeController from "./design_mode_controller"
application.register("design-mode", DesignModeController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import GeographySelectController from "./geography_select_controller"
application.register("geography-select", GeographySelectController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import ModerationWorkbenchController from "./moderation_workbench_controller"
application.register("moderation-workbench", ModerationWorkbenchController)

import EditorShortcutsController from "./editor_shortcuts_controller"
application.register("editor-shortcuts", EditorShortcutsController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import SearchFilterController from "./search_filter_controller"
application.register("search-filter", SearchFilterController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import RotatingTextController from "./rotating_text_controller"
application.register("rotating-text", RotatingTextController)

import SlideOverController from "./slide_over_controller"
application.register("slide-over", SlideOverController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import TurboPollController from "./turbo_poll_controller"
application.register("turbo-poll", TurboPollController)

import WaitlistFormController from "./waitlist_form_controller"
application.register("waitlist-form", WaitlistFormController)

import WaitlistSignupController from "./waitlist_signup_controller"
application.register("waitlist-signup", WaitlistSignupController)

import WebOauthController from "./web_oauth_controller"
application.register("web-oauth", WebOauthController)
